import * as Api from '../api/Api';
import createAxios from '../api/WiseOwl';

export function getSkills() {
    return createAxios().get(Api.PATH_SKILLS + "/info");
};

export const removeSkill = (id) => {
    return createAxios().delete(Api.PATH_SKILLS + "/" + id);
}

export const createSkill = (values) => {
    return createAxios().post(Api.PATH_SKILLS, values);
};

export const updateSkill = (id, values) => {
    return createAxios().put(`${Api.PATH_SKILLS}/${id}`, values);
};
